import * as React from "react";

export class Head extends React.Component<{}, {}> {
    render() {
        return (
            <thead>
                {this.props.children}
            </thead>
        );
    }
}